import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var AlertContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border: ", " solid;\n  border-left: ", " solid;\n  border-color: ", ";\n  display: flex;\n  width: ", ";\n  position: relative;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colours.canvas.tertiary.main;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.sizing.xxtiny;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.sizing.tiny;
}, function (_ref4) {
  var theme = _ref4.theme,
    $type = _ref4.$type;
  return theme.colours.messaging[$type].main;
}, function (_ref5) {
  var $isFullWidth = _ref5.$isFullWidth;
  return $isFullWidth ? '100%' : 'fit-content';
});
var IconContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding-left: ", ";\n  color: ", ";\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.sizing.small;
}, function (_ref7) {
  var theme = _ref7.theme,
    $type = _ref7.$type;
  return theme.colours.messaging[$type].main;
});
var AlertContent = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: ", ";\n  flex-grow: 1;\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.sizing.small;
});
var AlertContentChildren = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.sizing.small;
});
var CloseButtonContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding-inline: ", " 0;\n  padding-block: ", ";\n  align-self: ", ";\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.sizing.tiny;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.sizing.tiny;
}, function (_ref12) {
  var $isPositionTop = _ref12.$isPositionTop;
  return $isPositionTop ? 'flex-start' : 'center';
});

export { AlertContainer, AlertContent, AlertContentChildren, CloseButtonContainer, IconContainer };
//# sourceMappingURL=Alert.styles.js.map
